


// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// // Initial state
// const initialState = {
//   products: [],
//   loading: false,
//   error: null,
// };

// // Thunk for fetching products
// export const fetchProducts = createAsyncThunk(
//   'products/fetchProducts',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch('../api/product.json');
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       const data = await response.json();
//       console.log("Fetched Products:", data); // Debug log
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const productSlice = createSlice({
//   name: 'products',
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchProducts.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchProducts.fulfilled, (state, action) => {
//         state.products = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchProducts.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const selectProducts = (state) => state.products.products;
// export const selectProductLoading = (state) => state.products.loading;
// export const selectProductError = (state) => state.products.error;

// export default productSlice.reducer;





import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  products: [],
  loading: false,
  error: null,
};

// Thunk for fetching products
export const fetchProducts = createAsyncThunk('products/fetchProducts', async () => {
  const response = await fetch('../api/product.json'); // Ensure the path is correct
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data = await response.json();
  console.log('Fetched Products:', data);
  return data; // Return the data for fulfilled state
});

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {}, // No need for additional reducers here
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.products = action.payload; // Set fetched products
        state.loading = false;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // Use action.error.message for better clarity
      });
  },
});
// chrome.runtime.onMessage.addListener((request, sender, sendResponse) => {
//   // Do some async operation
//   asyncOperation().then(result => {
//     sendResponse({ result });
//   }).catch(error => {
//     console.error('Error in async operation:', error);
//     sendResponse({ error: error.message });
//   });
//   return true; // Keep the message channel open for sendResponse
// });


export const selectProducts = (state) => state.products.products;
export const selectProductLoading = (state) => state.products.loading;
export const selectProductError = (state) => state.products.error;

export default productSlice.reducer;



